import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { ModalSelecionarCamadasPage } from './modal-selecionar-camadas.page';

const routes: Routes = [
  {
    path: '',
    component: ModalSelecionarCamadasPage
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class ModalSelecionarCamadasPageRoutingModule {}
